import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "vp-page" }
const _hoisted_2 = { "vp-content": "" }

import VPPageMeta from '@theme/VPPageMeta.vue'
import VPPageNav from '@theme/VPPageNav.vue'
import type { VNode } from 'vue'
import { Content } from 'vuepress/client'


export default /*@__PURE__*/_defineComponent({
  __name: 'VPPage',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _renderSlot(_ctx.$slots, "top"),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "content-top"),
      _createVNode(_unref(Content)),
      _renderSlot(_ctx.$slots, "content-bottom")
    ]),
    _createVNode(VPPageMeta),
    _createVNode(VPPageNav),
    _renderSlot(_ctx.$slots, "bottom")
  ]))
}
}

})